import React from "react";
import {Link, useHistory} from "react-router-dom";

//helpers:
import {useTranslation} from "react-i18next";
import {parseSliderParams} from "../Util/ComponentHelper";

//components:
import {SwiperSlide} from "swiper/react";
import SimpleVideoSlide from "../Partials/Slides/SimpleVideoSlide";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CustomSlider from "../Partials/CustomSlider";

const DynamicListComponent = ({component}) => {
    const history = useHistory();
    const {t} = useTranslation();

    return (
        <div className="d-flex flex-column container">
            <div className="d-flex justify-content-between align-items-center mt-4">
                <h3 className="mb-3 home_carousels_title">
                    {component.context && component.context.name ? component.context.name : component.name}
                </h3>
                {component.context && component.context.track_id ? (
                    <Link to={`/track/${component.context.track_id}`} className="explore_track_badge">
                        <span className="d-flex">{t("HOME.BUTTON.EXPLORE")}</span>
                        <ArrowForwardIosIcon className="font-size-10px ml-1" />
                    </Link>
                ) : null}
            </div>
            <div className={"custom-slide"}>
                {component.data && component.data.length !== 0 ? (
                    <CustomSlider>
                        {component.data.map((item, i) => {
                            let {background, title, textLeft, textRight, callbackUrl, type_id} = parseSliderParams(
                                item
                            );
                            return (
                                <SwiperSlide key={i} className="movieShowcase__container--movie__netflix">
                                    <SimpleVideoSlide
                                        background={background}
                                        title={title}
                                        textLeft={textLeft}
                                        textRight={textRight}
                                        callback={() => history.push(callbackUrl)}
                                        type_id={type_id}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </CustomSlider>
                ) : null}
            </div>
        </div>
    );
};
export default DynamicListComponent;
